import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";
import api from "../../services/api";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
	messageMedia: {
		objectFit: "cover",
		width: 80,
		height: 50,
		borderRadius: 3,
		// paddingBottom: 6,
	},
}));

function ModalImageChatbot({ imageUrl }) {
	const classes = useStyles();
	const [fetching, setFetching] = useState(true);
	const [blobUrl, setBlobUrl] = useState("");

useEffect(() => {
	if (!imageUrl) return;

	if (!imageUrl.startsWith("http")) {
		setBlobUrl(imageUrl);
		setFetching(false);
		return;
	}

	const fetchImage = async () => {
		try {
			const { data, headers } = await axios.get(imageUrl, {
				responseType: "blob",
				withCredentials: false,
			});

			const url = window.URL.createObjectURL(
				new Blob([data], { type: headers["content-type"] })
			);

			setBlobUrl(url);
		} catch (err) {
			console.error(err);
		} finally {
			setFetching(false);
		}
	};

	fetchImage();
}, [imageUrl]);

	return (
		<ModalImage
			className={classes.messageMedia}
			smallSrcSet={fetching ? imageUrl : blobUrl}
			medium={fetching ? imageUrl : blobUrl}
			large={fetching ? imageUrl : blobUrl}
			showRotate="true"
			alt="image"
		/>
	);
}

export default ModalImageChatbot;
